export const PublicNfzStateIcon = () => (
  <svg
    width="20"
    height="9"
    viewBox="0 0 20 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1066 0H13.9963C13.2929 0 13.1612 1.0616 13.9963 1.0616H16.0073C16.2142 1.0616 16.2623 1.3058 16.2142 1.42789C15.5425 2.90586 13.8747 7.23007 13.8439 7.39701C13.6527 8.43094 14.529 8.97734 15.0492 8.9999H17.1723C17.3372 8.9858 17.6671 8.85864 17.6671 8.46278C17.6671 8.06692 17.3372 7.9454 17.1723 7.93413H15.1042C15.0281 7.95104 14.8033 7.82091 14.8672 7.64196C15.0118 7.23715 15.3711 6.35729 15.3711 6.35729C16.1465 4.50347 17.2878 1.86712 17.2878 1.42789C17.2878 0.301548 16.3956 0 16.1066 0Z"
      fill="#3D3D3D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2871 1.06878C10.0066 1.06878 9.73765 1.18019 9.53934 1.37851C9.34102 1.57682 9.22961 1.8458 9.22961 2.12626V8.47116C9.22961 8.76317 8.99288 8.9999 8.70086 8.9999C8.40885 8.9999 8.17212 8.76317 8.17212 8.47116V2.12626C8.17212 1.56534 8.39495 1.02739 8.79158 0.630754C9.18822 0.234121 9.72616 0.0112951 10.2871 0.0112951H11.8733C12.1653 0.0112951 12.4021 0.248021 12.4021 0.540036C12.4021 0.832052 12.1653 1.06878 11.8733 1.06878H10.2871Z"
      fill="#3D3D3D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.17109 5.29664C8.17109 5.00463 8.40782 4.7679 8.69983 4.7679H11.0792C11.3712 4.7679 11.6079 5.00463 11.6079 5.29664C11.6079 5.58866 11.3712 5.82538 11.0792 5.82538H8.69983C8.40782 5.82538 8.17109 5.58866 8.17109 5.29664Z"
      fill="#3D3D3D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.76176 0.0208875C3.01065 -0.027044 3.25854 0.108386 3.35267 0.343719L5.50546 5.72567V0.540088C5.50546 0.248073 5.74218 0.0113471 6.0342 0.0113471C6.32621 0.0113471 6.56294 0.248073 6.56294 0.540088V8.47121C6.56294 8.72467 6.38307 8.94248 6.13419 8.99041C5.8853 9.03834 5.63741 8.90291 5.54327 8.66758L3.39049 3.28562V8.47121C3.39049 8.76322 3.15376 8.99995 2.86175 8.99995C2.56973 8.99995 2.33301 8.76322 2.33301 8.47121V0.540088C2.33301 0.286627 2.51287 0.0688189 2.76176 0.0208875Z"
      fill="#3D3D3D"
    />
  </svg>
);
